/* global __ENV_VARS__ */
import * as Sentry from '@sentry/react'

/** Vite-injected mode string at build time; falls back to Node's NODE_ENV (e.g. Jest). */
function sentryReportedEnvironment(): string {
  if (typeof __NODE_ENV__ !== 'undefined' && __NODE_ENV__) {
    return __NODE_ENV__
  }

  return process.env.NODE_ENV ?? 'development'
}

/**
 * Initialize Sentry with basic error tracking and BrowserTracing
 */
export function initSentry(): void {
  const dsn = __ENV_VARS__.VITE_SENTRY_DSN

  const environment = sentryReportedEnvironment()

  if (!dsn) {
    console.warn('Sentry DSN not configured. Error tracking disabled.')
    return
  }

  // Session Replay attaches mutation observers and flush listeners that show up as resize-adjacent
  // overhead in CPU profiles; keep it off in development so local perf matches logged-in editing.
  const enableReplay = environment !== 'development'

  Sentry.init({
    dsn,
    environment,
    release: __APP_VERSION__,

    integrations: [
      Sentry.browserTracingIntegration(),
      ...(enableReplay
        ? [
            Sentry.replayIntegration({
              // Capture only errors, not all sessions
              // maskAllText: true,
              // blockAllMedia: true,
            }),
          ]
        : []),
    ],

    tracesSampleRate: 0.1,

    replaysSessionSampleRate: enableReplay ? 0.5 : 0,
    replaysOnErrorSampleRate: enableReplay ? 1.0 : 0,

    enableLogs: false,
  })

  // Set up global error handlers
  window.addEventListener('error', (event) => {
    Sentry.captureException(event.error)
  })

  window.addEventListener('unhandledrejection', (event) => {
    Sentry.captureException(event.reason)
  })
}
